@import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,300..900;1,9..144,300..900&family=Manrope:wght@200..800&display=swap');

@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  :root {
    color-scheme: light;
  }
  html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    scroll-behavior: smooth;
  }
  body {
    @apply bg-bone text-ink font-sans;
    font-feature-settings: 'ss01', 'ss02', 'cv11';
  }
  ::selection {
    @apply bg-gold/30 text-ink;
  }
  /* Focus visible global — acessibilidade teclado */
  *:focus-visible {
    outline: 2px solid #2B2620;
    outline-offset: 3px;
    border-radius: 2px;
  }
  button:focus-visible, a:focus-visible {
    outline: 2px solid #2B2620;
    outline-offset: 3px;
  }
}

@layer components {
  .container-editorial {
    @apply mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16;
  }
  .btn-primary {
    @apply inline-flex items-center justify-center gap-2 bg-ink text-bone px-6 py-3 rounded-full hover:bg-taupe-dark transition-colors text-sm tracking-wide;
  }
  .btn-ghost {
    @apply inline-flex items-center justify-center gap-2 border border-ink/20 text-ink px-6 py-3 rounded-full hover:border-ink/60 transition-colors text-sm tracking-wide;
  }
}
